import React from 'react';

interface SoftTronikSupplierConfigurationProps {
    configuration: {
        BaseUrl?: string;
    };
    onChange: (field: string, value: string | number) => void;
    disabled?: boolean;
}

interface SoftTronikConfigurationComponent extends React.FC<SoftTronikSupplierConfigurationProps> {
    configFields: string[];
}

const SoftTronikConfiguration: SoftTronikConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <div className="form-group-custom" style={{ gridColumn: '1 / -1' }}>
                <label className="form-label-custom">
                    <span className="label-icon">🌐</span>
                    Базовый URL
                </label>
                <div className="input-group-custom">
                    <input
                        type="url"
                        className="form-input-custom"
                        value={configuration.BaseUrl || ''}
                        onChange={(e) => onChange('BaseUrl', e.target.value)}
                        placeholder="https://api.softtronik.example.com"
                        disabled={disabled}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
SoftTronikConfiguration.configFields = ['BaseUrl'];

export default SoftTronikConfiguration;
